import { GtagConsent } from '#base/core/enums/GtagConsentEnum';

export default () => {
	const {
		isConsentGiven, hasConsentFor,
	} = useConsent();
	const config = useRuntimeConfig();

	useHead({
		script: [
			{
				defer: true,
				type: 'text/javascript',
				src: `https://www.googletagmanager.com/gtag/js?id=${config.public.gtagAnalyticsId}`,
			},
			{
				type: 'text/javascript',
				innerHTML: `
                    window.dataLayer=window.dataLayer || [];
                    function gtag() { dataLayer.push(arguments); }

                    gtag('consent', 'default', {
                        '${GtagConsent.AdStorage}': 'denied',
                        '${GtagConsent.AdUserData}': 'denied',
                        '${GtagConsent.AdPersonalization}': 'denied',
                        '${GtagConsent.AnalyticsStorage}': 'denied',
                        '${GtagConsent.FunctionalityStorage}': 'granted',
                        '${GtagConsent.PersonalizationStorage}': 'denied',
                        '${GtagConsent.SecurityStorage}': 'denied',
                        'wait_for_update': 500,
                    });
                    
                    gtag('js', new Date());
                
                    gtag('config', '${config.public.gtagAnalyticsId}', {'branch': '${config.public.branch}'});
                    gtag('config', '${config.public.gtagAdsId}', {'branch': '${config.public.branch}'});
                `,
			},
			() => {
				if (
					import.meta.server
						|| !isConsentGiven
						|| !hasConsentFor(GtagConsent.AdPersonalization)
				) {
					return {};
				}

				return {
					type: 'text/javascript',
					innerHTML: `
						!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
						fbq('init', '${config.public.metaPixelId}');
						fbq('track', 'PageView');
					`,
				};
			},
			() => {
				if (
					import.meta.server
						|| !isConsentGiven
						|| !hasConsentFor(GtagConsent.AdPersonalization)
				) {
					return {};
				}

				return {
					type: 'text/javascript',
					innerHTML: `
						!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
						fbq('init', '${config.public.metaPixelId}');
						fbq('track', 'PageView');
					`,
				};
			},
		],
		noscript: [
			`<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${config.public.metaPixelId}&ev=PageView&noscript=1" />`,
		],
	});
};
